import DropdownDirective from './directives/DropdownDirective';
import DropdownToggleDirective from './directives/DropdownToggleDirective';
import Dropdown from './directives/gw-dropdown/gwDropdownDirective';

export default angular.module('edge.platform.widgets.dropdown', []).directive('gwPlDropdown', DropdownDirective).directive('gwDropdownToggle', DropdownToggleDirective).directive('gwDropdown', Dropdown);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/dropdown/module.js
// module id = 355
// module chunks = 0